import e from"./ClearRefinements.vue_vue&type=script&lang.js";import{render as t}from"./ClearRefinements.vue_vue&type=template&id=302b873a&lang.js";e.render=t;export default e;
//# sourceMappingURL=ClearRefinements.vue.js.map
